import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const DictSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 32 32"
  >
    <g transform="translate(-4 -4)">
      <path
        d="M24.4,2,17.9,7.85v14.3l6.5-5.85V2M8.15,5.9A12.09,12.09,0,0,0,1,7.85V26.908a.7.7,0,0,0,.65.65c.13,0,.195-.091.325-.091A15.85,15.85,0,0,1,8.15,26.05,12.09,12.09,0,0,1,15.3,28a15.659,15.659,0,0,1,7.15-1.95,13.241,13.241,0,0,1,6.175,1.378.565.565,0,0,0,.325.039.7.7,0,0,0,.65-.65V7.85A8.867,8.867,0,0,0,27,6.55V24.1a15.106,15.106,0,0,0-4.55-.65A15.659,15.659,0,0,0,15.3,25.4V7.85A12.09,12.09,0,0,0,8.15,5.9Z"
        transform="translate(5 4)"
      />
    </g>
  </svg>
);

const TermSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
  </svg>
);

const SuggestionSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 235 235">
    <path d="M 159.635,82.894 C 148.467,72.784 133.286,65 117,65 100.715,65 85.656,72.783 74.487,82.894 62.844,93.434 56.431,106.871 56.431,123 c 0,27.668 15.389,43.912 20.445,48.839 1.361,1.326 4.104,4.766 7.428,9.145 -2.43,2.298 -3.934,5.412 -3.934,8.844 0,4.016 2.053,7.599 5.249,9.943 -0.298,0.974 -0.47,1.995 -0.47,3.055 0,3.836 2.096,7.228 5.292,9.293 -0.499,1.149 -0.781,2.602 -0.781,3.911 0,5.556 4.935,8.97 11,8.97 h 32.802 c 6.064,0 10.999,-3.414 10.999,-8.97 0,-1.309 -0.283,-2.66 -0.781,-3.808 3.196,-2.064 5.293,-5.508 5.293,-9.344 0,-1.06 -0.172,-2.107 -0.47,-3.081 3.196,-2.344 5.248,-5.94 5.248,-9.956 0,-3.36 -1.445,-6.419 -3.786,-8.702 3.46,-4.511 6.319,-8.068 7.721,-9.43 13.461,-13.067 20.005,-29.843 20.005,-48.709 0,-16.129 -6.413,-29.566 -18.056,-40.106 z M 117,80 l 43,55 h -29.273 v 75 h -28 V 135 H 74 Z" />
    <path d="m 117,60.8955 c 6.56,0 16,-5.317 16,-11.877 V 19.688 c 0,-6.56 -9.44,-11.877 -16,-11.877 -6.56,0 -16,5.317 -16,11.877 v 29.3315 c 0,6.559 9.44,11.876 16,11.876 z" />
    <path d="m 222.244,106 h -29.3305 c -6.56,0 -11.877,10.44 -11.877,17 0,6.56 5.317,17 11.877,17 h 29.3305 c 6.56,0 11.877,-10.44 11.877,-17 0,-6.56 -5.317,-17 -11.877,-17 z" />
    <path d="M 41.2085,106 H 11.877 C 5.317,106 0,116.44 0,123 c 0,6.56 5.317,17 11.877,17 h 29.3315 c 6.56,0 11.877,-10.44 11.877,-17 0,-6.56 -5.317,-17 -11.877,-17 z" />
    <path d="M 72.31325,55.08925 49.63875,33.98275 C 44.76375,29.59475 34.2525,32.991 29.8655,37.866 c -4.388,4.876 -6.99275,15.38625 -2.11675,19.77325 l 22.6745,21.1055 c 2.27,2.043 5.84469,1.464413 8.67569,1.464413 3.25,0 8.75206,-2.741663 11.09706,-5.347663 4.387,-4.875 6.99225,-15.38425 2.11725,-19.77225 z" />
    <path d="m 204.2555,37.8645 c -4.39,-4.877 -13.898,-8.27125 -18.773,-3.88325 l -22.673,21.1075 c -4.876,4.389 -3.271,14.89825 1.117,19.77325 2.346,2.606 5.582,5.347663 8.832,5.347663 2.831,0 8.672,0.578587 10.941,-1.464413 l 22.673,-21.1065 c 4.876,-4.389 2.271,-14.89925 -2.117,-19.77425 z" />
  </svg>
);

const LockSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4416"
    width="1em"
    height="1em"
  >
    <path
      d="M512.804571 73.142857a207.238095 207.238095 0 0 1 207.238096 207.238095l-0.024381 60.952381H828.952381a73.142857 73.142857 0 0 1 73.142857 73.142857v438.857143a73.142857 73.142857 0 0 1-73.142857 73.142857H195.047619a73.142857 73.142857 0 0 1-73.142857-73.142857V414.47619a73.142857 73.142857 0 0 1 73.142857-73.142857h110.494476v-60.952381a207.238095 207.238095 0 0 1 207.238095-207.238095zM828.952381 414.47619H195.047619v438.857143h633.904762V414.47619z m-273.383619 121.904762v195.047619h-73.142857v-195.047619h73.142857zM512.804571 146.285714a134.095238 134.095238 0 0 0-134.095238 134.095238V341.333333h268.190477v-60.952381a134.095238 134.095238 0 0 0-134.095239-134.095238z"
      p-id="4417"
      fill="currentColor"
    ></path>
  </svg>
);

const UnLockSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7678"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path
      d="M524.190476 73.142857a207.238095 207.238095 0 0 1 207.238095 207.238095v12.190477h-73.142857v-12.190477a134.095238 134.095238 0 0 0-268.190476 0V341.333333h438.857143a73.142857 73.142857 0 0 1 73.142857 73.142857v438.857143a73.142857 73.142857 0 0 1-73.142857 73.142857H195.047619a73.142857 73.142857 0 0 1-73.142857-73.142857V414.47619a73.142857 73.142857 0 0 1 73.142857-73.142857h121.904762v-60.952381A207.238095 207.238095 0 0 1 524.190476 73.142857zM828.952381 414.47619H195.047619v438.857143h633.904762V414.47619z m-268.190476 121.904762v195.047619h-73.142857v-195.047619h73.142857z"
      p-id="7679"
    ></path>
  </svg>
);

const UnLockFillSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7846"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path
      d="M524.190476 73.142857a207.238095 207.238095 0 0 1 207.238095 207.238095v12.190477h-73.142857v-12.190477a134.095238 134.095238 0 0 0-268.190476 0V341.333333h438.857143a73.142857 73.142857 0 0 1 73.142857 73.142857v438.857143a73.142857 73.142857 0 0 1-73.142857 73.142857H195.047619a73.142857 73.142857 0 0 1-73.142857-73.142857V414.47619a73.142857 73.142857 0 0 1 73.142857-73.142857h121.904762v-60.952381A207.238095 207.238095 0 0 1 524.190476 73.142857zM560.761905 536.380952h-73.142857v195.047619h73.142857v-195.047619z"
      p-id="7847"
    ></path>
  </svg>
);

const HandOutlined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1704"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path
      d="M870.4 204.8c-18.6368 0-36.1472 5.0176-51.2 13.7728l0-64.9728c0-56.4736-45.9264-102.4-102.4-102.4-21.0944 0-40.6528 6.4-56.9856 17.3568-14.0288-39.8848-52.0192-68.5568-96.6144-68.5568s-82.6368 28.672-96.6144 68.5568c-16.2816-10.9568-35.8912-17.3568-56.9856-17.3568-56.4736 0-102.4 45.9264-102.4 102.4l0 377.4976-68.9152-119.4496c-13.3632-24.32-35.1744-41.6256-61.3888-48.7936-25.5488-6.9632-52.1216-3.2768-74.8544 10.3424-46.4384 27.8528-64.1536 90.8288-39.424 140.3904 1.536 3.1232 34.2016 70.0416 136.192 273.92 48.0256 96 100.7104 164.6592 156.6208 203.9808 43.8784 30.8736 74.1888 32.4608 79.8208 32.4608l256 0c43.5712 0 84.0704-14.1824 120.4224-42.0864 34.1504-26.2656 63.7952-64.256 88.064-112.8448 47.8208-95.6416 73.1136-227.9424 73.1136-382.6688l0-179.2c0-56.4736-45.9264-102.4-102.4-102.4zM921.6 486.4c0 146.7904-23.3984 271.1552-67.6864 359.7312-28.8768 57.7536-80.5888 126.6688-162.7136 126.6688l-255.488 0c-1.9968-0.1536-23.552-2.56-56.064-26.88-32.4096-24.2688-82.176-75.3664-135.0656-181.248-103.7824-207.5648-135.68-272.9472-135.9872-273.5616-0.0512-0.1024-0.0512-0.1536-0.1024-0.2048-12.8512-25.7536-3.7376-59.4944 19.9168-73.6768 10.6496-6.4 23.0912-8.0896 35.072-4.864 12.7488 3.4816 23.4496 12.0832 30.0544 24.1664 0.1024 0.1536 0.2048 0.3584 0.3072 0.512l79.9232 138.496c16.3328 29.8496 34.7136 42.3936 54.6304 37.3248 19.968-5.0688 30.0544-25.0368 30.0544-59.2384l0-400.0256c0-28.2112 22.9888-51.2 51.2-51.2s51.2 22.9888 51.2 51.2l0 332.8c0 14.1312 11.4688 25.6 25.6 25.6s25.6-11.4688 25.6-25.6l0-384c0-28.2112 22.9888-51.2 51.2-51.2s51.2 22.9888 51.2 51.2l0 384c0 14.1312 11.4688 25.6 25.6 25.6s25.6-11.4688 25.6-25.6l0-332.8c0-28.2112 22.9888-51.2 51.2-51.2s51.2 22.9888 51.2 51.2l0 384c0 14.1312 11.4688 25.6 25.6 25.6s25.6-11.4688 25.6-25.6l0-230.4c0-28.2112 22.9888-51.2 51.2-51.2s51.2 22.9888 51.2 51.2l0 179.2z"
      p-id="1705"
    ></path>
  </svg>
);

const ColumnOutlined = () => (
  <svg
    viewBox="150 150 874 874"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="865"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path
      d="M824.888889 170.666667H199.111111a56.888889 56.888889 0 0 0-56.888889 56.888889v568.888888a56.888889 56.888889 0 0 0 56.888889 56.888889h625.777778a56.888889 56.888889 0 0 0 56.888889-56.888889V227.555556a56.888889 56.888889 0 0 0-56.888889-56.888889z m0 597.333333a28.444444 28.444444 0 0 1-28.444445 28.444444H227.555556a28.444444 28.444444 0 0 1-28.444445-28.444444V256a28.444444 28.444444 0 0 1 28.444445-28.444444h568.888888a28.444444 28.444444 0 0 1 28.444445 28.444444z"
      p-id="1478"
    ></path>
    <path
      d="M512 256m28.444444 0l227.555556 0q28.444444 0 28.444444 28.444444l0 455.111112q0 28.444444-28.444444 28.444444l-227.555556 0q-28.444444 0-28.444444-28.444444l0-455.111112q0-28.444444 28.444444-28.444444Z"
      p-id="1479"
    ></path>
  </svg>
);

const ChapterOutlined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1463"
    width="1em"
    height="1em"
  >
    <path
      d="M311.1 630.9c-22.2 0-40.3 18-40.3 40.3s18 40.3 40.3 40.3c22.2 0 40.3-18 40.3-40.3-0.1-22.3-18.1-40.3-40.3-40.3z m0-80.6c22.1-0.2 39.9-18.2 39.9-40.3 0-22.1-17.8-40-39.9-40.3-14.5-0.1-27.9 7.5-35.2 20-7.3 12.5-7.3 28 0 40.5a39.93 39.93 0 0 0 35.2 20.1z m161.1-161.1h241.7c14.4 0 27.7-7.7 34.9-20.1 7.2-12.5 7.2-27.8 0-40.3s-20.5-20.1-34.9-20.1H472.2c-14.4 0-27.7 7.7-34.9 20.1-7.2 12.5-7.2 27.8 0 40.3 7.2 12.4 20.5 20.1 34.9 20.1zM282.556 377.375c15.738 15.738 41.255 15.737 56.993-0.001s15.737-41.255-0.001-56.993-41.255-15.737-56.993 0.001c-15.738 15.739-15.737 41.255 0.001 56.993z"
      fill="#333333"
      p-id="1464"
    ></path>
    <path
      d="M834.7 67H190.2c-44.5 0-80.6 36.1-80.6 80.6v725c0 44.5 36.1 80.5 80.6 80.5h644.4c44.5 0 80.5-36.1 80.5-80.5v-725c0.1-44.5-35.9-80.6-80.4-80.6z m0 765.2c0 22.2-18 40.3-40.3 40.3H230.5c-10.7 0-20.9-4.2-28.5-11.8a40.182 40.182 0 0 1-11.8-28.5V187.8c0-22.2 18-40.3 40.3-40.3h563.9c10.7 0 20.9 4.2 28.5 11.8s11.8 17.8 11.8 28.5v644.4z"
      fill="#333333"
      p-id="1465"
    ></path>
    <path
      d="M713.8 630.9H472.2c-22.2 0-40.3 18-40.3 40.3s18 40.3 40.3 40.3h241.7c22.2 0 40.3-18 40.3-40.3-0.1-22.3-18.1-40.3-40.4-40.3z m-241.6-80.6h241.7c22.1-0.2 39.9-18.2 39.9-40.3 0-22.1-17.8-40-39.9-40.3H472.2c-14.5-0.1-27.9 7.5-35.2 20-7.3 12.5-7.3 28 0 40.5a39.93 39.93 0 0 0 35.2 20.1z"
      fill="#333333"
      p-id="1466"
    ></path>
  </svg>
);

const ArticleOutlined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4245"
    width="1em"
    height="1em"
  >
    <path
      d="M258.9696 716.8h411.9552v24.064c0 54.6816 13.2096 79.36 39.6288 83.6608 23.2448-3.8912 40.2432-23.9616 40.2432-47.5136V276.0704c-1.4336-71.9872 29.0816-114.3808 88.8832-114.3808V209.92c-29.0816 0-41.6768 17.5104-40.7552 65.6384v501.4528c0 47.8208-35.0208 88.3712-82.2272 95.3344v1.024H234.9056c-53.248 0-96.3584-43.1104-96.3584-96.3584V716.8h72.2944V246.8864c0-53.248 43.1104-96.3584 96.3584-96.3584h489.472c57.6512 0 88.8832 37.888 88.8832 102.6048v113.8688h-110.592v-48.2304h62.3616v-65.6384c0-39.936-11.9808-54.4768-40.7552-54.4768H307.2c-26.624 0-48.2304 21.6064-48.2304 48.2304V716.8z m99.2256 108.4416h280.8832c-8.192-16.2816-13.312-36.5568-15.2576-60.2112H186.6752v12.0832c0 26.624 21.6064 48.2304 48.2304 48.2304l123.2896-0.1024z m-17.1008-427.7248c-13.312 0-24.064-10.752-24.064-24.064s10.752-24.064 24.064-24.064h325.2224c13.312 0 24.064 10.752 24.064 24.064s-10.752 24.064-24.064 24.064H341.0944z m0.1024 132.608c-13.312 0-24.064-10.752-24.064-24.064s10.752-24.064 24.064-24.064h164.5568c13.312 0 24.064 10.752 24.064 24.064s-10.752 24.064-24.064 24.064H341.1968z"
      p-id="4246"
    ></path>
  </svg>
);

const ParagraphOutlined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4639"
    width="1em"
    height="1em"
  >
    <path
      d="M122.368 165.888h778.24c-9.216 0-16.384-7.168-16.384-16.384v713.728c0-9.216 7.168-16.384 16.384-16.384h-778.24c9.216 0 16.384 7.168 16.384 16.384V150.016c0 8.192-6.656 15.872-16.384 15.872z m-32.768 684.544c0 26.112 20.992 47.104 47.104 47.104h750.08c26.112 0 47.104-20.992 47.104-47.104V162.304c0-26.112-20.992-47.104-47.104-47.104H136.704c-26.112 0-47.104 20.992-47.104 47.104v688.128z"
      p-id="4640"
    ></path>
    <path
      d="M597.504 300.544h230.912v49.152h-230.912zM596.992 437.76h230.912v49.152h-230.912zM210.432 574.976h617.984v49.152H210.432zM210.432 712.192h617.984v49.152H210.432zM246.784 296.448h88.064V501.76h-29.184v29.184h117.248V501.76h-29.696V296.448H481.28v29.184h29.184V238.08H217.6v87.552h29.184z"
      p-id="4641"
    ></path>
  </svg>
);

const ProgressOutlined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2309"
    width="1em"
    height="1em"
  >
    <path
      d="M537.6 469.7088V486.4h409.6v25.6A435.2 435.2 0 1 1 512 76.8h25.6v392.9088zM128 512a384 384 0 0 0 767.1808 25.6H486.4V512 128.8192A384 384 0 0 0 128 512z m794.6752-144.3328a25.6 25.6 0 0 1-48.2816 16.9984 385.1264 385.1264 0 0 0-235.3152-235.1616 25.6 25.6 0 0 1 16.9472-48.2816 436.3264 436.3264 0 0 1 266.6496 266.4448z"
      p-id="2310"
    ></path>
  </svg>
);

const StartUp = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1562"
    width="1em"
    height="1em"
  >
    <path
      d="M920.216 373.282s-155.09-84.012-266.406-44.552c-68.234 24.182-103.976 99.07-79.888 167.336 24.276 68.172 99.198 103.82 167.462 79.638 111.286-39.46 178.832-202.422 178.832-202.422z"
      fill="#A0D468"
      p-id="1563"
    ></path>
    <path
      d="M766.408 401.338a21.246 21.246 0 0 0-7.308 0c-2.812 0.468-69.172 12.09-142.282 51.52-31.43 16.902-59.392 36.49-83.48 58.33v-160.932h-42.662V557.52c-27.556 36.21-46.504 76.952-56.378 121.472l41.646 9.216c8.904-40.118 26.354-76.764 51.956-109.13h5.438v-6.654a305.138 305.138 0 0 1 5.544-6.406c25.666-28.774 58.346-54.018 97.088-75.044 67.078-36.398 129.688-47.488 130.312-47.614 8.624-1.5 15.778-8.186 17.402-17.278 2.064-11.624-5.684-22.684-17.276-24.744z"
      fill="#8CC153"
      p-id="1564"
    ></path>
    <path
      d="M216.568 812.554S372.19 556.082 512 554.646c139.81-1.468 295.432 257.908 295.432 257.908H216.568z"
      fill="#434A54"
      p-id="1565"
    ></path>
    <path
      d="M901.69 735.26c-6.684-0.532-14.028-0.782-22.086-0.782-52.488 0-134.22 11.186-246.226 30.932-13.934-39.742-102.476-57.176-102.476-57.176s-191.096-10.402-313.068-17.056c-7.78-0.438-15.31-0.624-22.558-0.624-161.572-0.032-195.158 100.82-195.158 100.82v104.476c0.062 59.89 184.66 89.26 185.286 89.354 146.638 28.962 326.864 38.68 326.864 38.68s493.87-194.05 506.836-205.39c12.964-11.312 7.276-73.236-117.414-83.234z"
      fill="#EAC6BB"
      p-id="1566"
    ></path>
    <path
      d="M771.784 743.446c-38.804 5.156-84.042 12.404-135.75 21.496a1341.336 1341.336 0 0 1-20.34 8.904C480.164 831.676 384.312 843.8 327.778 843.8c-11.778 0-21.324 9.558-21.324 21.338s9.544 21.308 21.324 21.308c88.198 0 190.924-24.776 305.32-73.64 69.17-29.588 120.782-58.832 138.686-69.36z"
      fill="#DBADA2"
      p-id="1567"
    ></path>
    <path
      d="M646.904 149.394C622.944 98.968 571.548 64.102 512 64.102s-110.958 34.868-134.922 85.292h-14.372v63.986c0 82.45 66.844 149.308 149.294 149.308 82.448 0 149.308-66.86 149.308-149.308V149.394h-14.404z"
      fill="#F6BB42"
      p-id="1568"
    ></path>
    <path
      d="M661.308 149.394c0 82.45-66.862 149.31-149.308 149.31-82.45 0-149.294-66.862-149.294-149.31S429.55 0.118 512 0.118c82.448 0 149.308 66.828 149.308 149.276z"
      fill="#FFCE54"
      p-id="1569"
    ></path>
    <path
      d="M533.338 106.748h-0.032c0-11.56-9.202-21.056-20.806-21.338-11.78-0.25-21.542 9.06-21.824 20.838 0 0.156 0.016 0.312 0.016 0.5h-0.016v85.324h0.016c0 11.53 9.202 21.028 20.808 21.308 11.778 0.282 21.542-9.06 21.822-20.84 0-0.156-0.016-0.312-0.016-0.468h0.032V106.748z"
      fill="#E8AA3D"
      p-id="1570"
    ></path>
  </svg>
);

const TermOutlined = () => (
  <svg
    viewBox="0 0 1346 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4153"
    width="1em"
    height="1em"
  >
    <path
      d="M1320.940453 319.434073L724.857384 13.866954a123.249191 123.249191 0 0 0-113.593725 0L23.70012 319.718057a44.017568 44.017568 0 0 0 0 78.095685l56.796862 28.398431v289.663998a72.415999 72.415999 0 1 0 70.428109 0v-252.462053l156.191371 80.935529v316.926491a87.183183 87.183183 0 0 0 61.056627 85.195293l186.577693 59.352721a393.034286 393.034286 0 0 0 117.001536 18.174996 378.267102 378.267102 0 0 0 112.173803-16.755074l200.492923-61.056627a87.467168 87.467168 0 0 0 62.192564-83.491388V539.521914L1320.940453 397.813742a44.017568 44.017568 0 0 0 23.854682-39.189835 44.585537 44.585537 0 0 0-23.854682-39.189834zM975.61553 860.992154a17.607027 17.607027 0 0 1-12.495309 16.755074L762.627297 937.383933a312.382742 312.382742 0 0 1-187.713629 0l-186.293708-59.068736a17.607027 17.607027 0 0 1-12.211326-16.755075v-280.860483l235.422994 122.397238a125.237081 125.237081 0 0 0 56.796862 13.915231 122.681222 122.681222 0 0 0 56.796862-13.631247l251.6101-129.212862z m-283.984311-220.087841a52.537098 52.537098 0 0 1-48.277332 0L101.227837 358.339923l543.261987-281.996421a51.969129 51.969129 0 0 1 48.277333 0l550.361594 281.996421z"
      p-id="4154"
    ></path>
  </svg>
);

const Term = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5672"
    width="1em"
    height="1em"
  >
    <path
      d="M929.2 228.4L523.5 34.9c-11.9-8.1-27.8-9.7-41.6-2.8L60.6 244.2c-0.5 0.2-0.9 0.5-1.4 0.7-8.2 3.9-15.1 10.5-19.3 19.3-9.7 20.4-1.1 44.9 19.3 54.6l412 196.5c2 0.9 4 1.7 6 2.3 9.9 3.3 21.2 2.8 31.2-2.3l346-174.2v261c0 22.6 18.3 41 41 41 22.6 0 41-18.3 41-41v-303c8.4-6.4 13.7-15.6 15.4-25.6 3.6-18-5.3-36.8-22.6-45.1z"
      p-id="5673"
    ></path>
    <path
      d="M818.1 458.3c-7.5-13.3-22.8-20.8-38.4-20.2h-1.3c-6.5 0.4-12.6 2.2-17.9 5L489.3 565.7 255.5 465.6c-5.8-2.8-12.3-4.3-19.3-4.3-22.6 0-41 16.5-41 36.7v219.4c0 0.6 0 1.3 0.1 1.9 2.3 99.8 141.8 180.3 313.4 180.3 170.8 0 309.7-79.7 313.4-178.7 0.1-0.8 0.1-1.5 0.1-2.3V478.4c0.8-6.7-0.5-13.7-4.1-20.1z"
      fill="#242424"
      p-id="5674"
    ></path>
  </svg>
);

const JsonOutlined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1557"
    width="1em"
    height="1em"
  >
    <path
      d="M742.4 755.456H564.770133c-14.4384 0-26.112 12.475733-26.112 27.869867v168.618666h28.433067L742.4 760.439467v-4.983467zM742.4 699.733333v-88.183466c0-15.189333 11.4688-27.477333 25.6-27.477334s25.6 12.288 25.6 27.477334v160.136533c0 7.2192-2.645333 14.1312-7.338667 19.285333L596.087467 998.7072a24.746667 24.746667 0 0 1-18.261334 8.226133H194.56C129.536 1006.933333 76.8 950.306133 76.8 880.452267V143.530667C76.8 73.693867 129.536 17.066667 194.56 17.066667h481.28C740.864 17.066667 793.6 73.693867 793.6 143.547733v48.930134c0 15.189333-11.4688 27.477333-25.6 27.477333s-25.6-12.288-25.6-27.477333V143.530667c0-39.4752-29.7984-71.492267-66.56-71.492267H194.56c-36.7616 0-66.56 32.017067-66.56 71.509333v736.887467c0 39.4752 29.7984 71.492267 66.56 71.492267H486.4v-168.618667C486.4 737.160533 521.489067 699.733333 564.770133 699.733333H742.4zM289.058133 294.570667h33.3824l-15.581866 153.275733c-2.645333 26.026667-9.437867 45.056-20.4288 57.7536-12.1856 13.329067-29.986133 20.002133-53.674667 20.002133-20.548267 0-35.601067-6.3488-44.868267-19.0464-9.557333-12.6976-13.192533-30.139733-10.939733-52.360533l0.733867-7.304533h33.399466l-0.7168 6.997333c-2.645333 26.0096 6.024533 39.0144 26.282667 39.0144 11.127467 0 19.797333-3.805867 25.668267-11.093333 5.888-7.304533 9.642667-19.0464 11.281066-35.2256l15.4624-152.0128z m144.128-4.437334c23.978667 0 42.257067 5.393067 54.545067 16.503467 13.073067 11.741867 19.473067 30.139733 18.944 54.903467H473.6c-1.4336-13.9776-5.819733-24.132267-12.629333-30.1568-6.775467-6.3488-17.902933-9.198933-32.733867-9.198934-12.8512 0-22.7328 1.911467-30.0032 6.024534-9.045333 4.778667-13.858133 12.6976-14.9504 23.483733-0.9728 9.5232 2.798933 17.4592 11.912533 23.176533 4.027733 2.525867 15.240533 7.287467 33.399467 13.960534 26.709333 9.506133 43.6224 17.134933 51.0976 22.203733 16.503467 11.741867 23.7056 27.938133 21.572267 48.878933-2.048 20.309333-10.837333 36.488533-26.299734 48.2304-15.428267 11.434667-36.3008 17.4592-62.276266 17.4592-25.105067 0-44.253867-5.393067-57.1392-16.196266-15.7696-13.312-23.04-34.269867-21.538134-63.146667h33.109334c0.512 17.134933 4.693333 29.525333 12.8 36.8128 7.338667 6.3488 19.2512 9.8304 36.096 9.8304 14.848 0 27.101867-2.850133 36.215466-8.2432 9.147733-5.717333 14.455467-13.0048 15.428267-22.528 1.211733-12.066133-4.369067-21.589333-16.213333-28.5696-3.771733-2.218667-16.384-7.287467-38.161067-14.916267-24.200533-8.874667-39.253333-15.223467-44.868267-19.029333-14.626133-10.478933-20.7872-25.7024-18.7392-45.704533 2.030933-19.985067 11.0592-35.84 27.630934-47.274667 15.394133-11.093333 33.928533-16.503467 55.893333-16.503467z m207.223467 0c31.112533 0 54.528 11.093333 70.212267 33.621334 14.9504 21.282133 20.650667 49.527467 17.1008 84.4288-3.549867 34.901333-14.9504 62.8224-34.235734 84.087466-20.241067 22.2208-45.909333 33.3312-77.0048 33.3312-31.402667 0-54.784-11.434667-70.212266-33.6384-14.933333-21.589333-20.360533-49.5104-16.878934-83.797333 3.515733-34.577067 14.626133-62.498133 33.962667-84.0704C583.338667 301.226667 609.006933 290.133333 640.392533 290.133333z m-3.242667 32.682667c-21.128533 0-38.1952 7.936-51.5072 23.808-12.680533 15.223467-20.1728 35.5328-22.818133 61.559467-2.6112 25.7024 0.750933 46.011733 10.325333 61.252266 9.847467 15.530667 25.582933 23.466667 46.6944 23.466667 21.128533 0 38.161067-7.611733 51.0976-22.528 12.629333-14.916267 20.445867-35.5328 23.159467-62.190933 2.7136-26.658133-0.8704-47.616-10.4448-62.839467-9.864533-15.223467-25.3952-22.528-46.506667-22.528z m131.84-28.245333h33.3824l84.1216 163.4304h1.143467l16.605867-163.4304h33.672533l-23.04 226.577066h-32.529067L797.354667 355.498667h-1.143467l-16.8448 165.649066H745.984l23.04-226.577066z"
      fill="currentColor"
      p-id="1558"
    ></path>
  </svg>
);

const ThemeOutlined = () => (
  <svg
    viewBox="190 190 750 750"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1557"
    width="1em"
    height="1em"
  >
    <path
      d="M512 853.333333c-55.466667 0-21.333333-38.4-85.333333-102.4-59.733333-64-256-25.6-256-238.933333 0-187.733333 153.6-341.333333 341.333333-341.333333s341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m256-341.333333c0-140.8-115.2-256-256-256s-256 115.2-256 256c0 68.266667 21.333333 89.6 81.066667 110.933333 4.266667 0 12.8 4.266667 21.333333 4.266667 4.266667 0 17.066667 4.266667 21.333333 8.533333 55.466667 17.066667 81.066667 29.866667 106.666667 55.466667 21.333333 21.333333 34.133333 42.666667 46.933333 64 0 4.266667 4.266667 8.533333 4.266667 12.8 128-12.8 230.4-123.733333 230.4-256z m-128-85.333333c-25.6 0-42.666667-17.066667-42.666667-42.666667s17.066667-42.666667 42.666667-42.666667 42.666667 17.066667 42.666667 42.666667-17.066667 42.666667-42.666667 42.666667z m-119.466667-55.466667c-25.6 0-42.666667-17.066667-42.666666-42.666667s17.066667-42.666667 42.666666-42.666666 42.666667 17.066667 42.666667 42.666666-17.066667 42.666667-42.666667 42.666667z m183.466667 162.133333c-25.6 0-42.666667-17.066667-42.666667-42.666666s17.066667-42.666667 42.666667-42.666667 42.666667 17.066667 42.666667 42.666667-17.066667 42.666667-42.666667 42.666666zM392.533333 413.866667c-25.6 0-42.666667-17.066667-42.666666-42.666667s17.066667-42.666667 42.666666-42.666667 42.666667 17.066667 42.666667 42.666667-17.066667 42.666667-42.666667 42.666667z m196.266667 298.666666c-34.133333 0-64-29.866667-64-64s29.866667-64 64-64 64 29.866667 64 64c-4.266667 34.133333-29.866667 64-64 64z"
      fill="currentColor"
      p-id="3496"
    ></path>
  </svg>
);

const TemplateOutLined = () => (
  <svg
    viewBox="0 0 1045 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4076"
    width="1em"
    height="1em"
  >
    <path
      d="M853.333333 10.666667H341.333333A117.333333 117.333333 0 0 0 224 128v42.666667A32 32 0 0 0 256 202.666667h448l3.477333 0.085333C734.976 204.117333 757.333333 227.541333 757.333333 256v597.333333a32 32 0 0 0 32 32h64a117.333333 117.333333 0 0 0 117.333334-117.333333V128A117.333333 117.333333 0 0 0 853.333333 10.666667z m-512 64h512A53.333333 53.333333 0 0 1 906.666667 128v640l-0.106667 3.498667A53.333333 53.333333 0 0 1 853.333333 821.333333h-32V256a117.333333 117.333333 0 0 0-111.509333-117.184l-5.034667-0.149333H288V128A53.333333 53.333333 0 0 1 341.333333 74.666667z"
      fill="currentColor"
      p-id="4077"
    ></path>
    <path
      d="M704 138.666667H192A117.333333 117.333333 0 0 0 74.666667 256v640A117.333333 117.333333 0 0 0 192 1013.333333h512a117.333333 117.333333 0 0 0 117.333333-117.333333V256A117.333333 117.333333 0 0 0 704 138.666667z m-512 64h512a53.333333 53.333333 0 0 1 53.333333 53.333333v640a53.333333 53.333333 0 0 1-53.333333 53.333333H192A53.333333 53.333333 0 0 1 138.666667 896V256A53.333333 53.333333 0 0 1 192 202.666667z"
      fill="currentColor"
      p-id="4078"
    ></path>
    <path
      d="M618.666667 554.666667a32 32 0 0 1 3.072 63.850666L618.666667 618.666667H277.333333a32 32 0 0 1-3.072-63.850667L277.333333 554.666667h341.333334zM448 746.666667a32 32 0 0 1 3.072 63.850666L448 810.666667h-170.666667a32 32 0 0 1-3.072-63.850667L277.333333 746.666667h170.666667zM618.666667 362.666667a32 32 0 0 1 3.072 63.850666L618.666667 426.666667H277.333333a32 32 0 0 1-3.072-63.850667L277.333333 362.666667h341.333334z"
      fill="currentColor"
      p-id="4079"
    ></path>
  </svg>
);

const CommentOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4420"
    width="1em"
    height="1em"
  >
    <path
      d="M481.578667 968.832l-157.909334-158.293333H85.418667A85.290667 85.290667 0 0 1 0 725.12L0.426667 128.042667C0.426667 80.768 38.4 42.666667 85.845333 42.666667h852.778667c47.189333 0 85.418667 38.101333 85.376 85.418666l-0.426667 597.12c0 47.146667-38.229333 85.333333-85.376 85.333334h-237.781333l-158.549333 158.293333a42.624 42.624 0 0 1-60.288 0z m456.704-243.712L938.666667 128.042667s-852.906667-0.128-852.906667 0.042666c0 0-0.384 597.077333-0.298667 597.077334H341.333333c11.306667 0 22.186667 4.48 30.165334 12.501333l140.330666 140.629333 140.8-140.672a42.624 42.624 0 0 1 30.165334-12.458666h255.488zM277.333333 512a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m234.666667 0a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m234.666667 0a64 64 0 1 1 0-128 64 64 0 0 1 0 128z"
      fill="currentColor"
      p-id="4421"
    ></path>
  </svg>
);

const CommentFill = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
  >
    <path
      d="M10.26,0.543H1.74c-0.852,0-1.521,0.669-1.521,1.521v6.694c0,0.853,0.669,1.521,1.521,1.521h2.647l1.399,1.43
	C5.848,11.771,5.909,11.802,6,11.802c0.092,0,0.152-0.031,0.213-0.092l1.43-1.43h2.617c0.821,0,1.521-0.669,1.521-1.521V2.064
	C11.781,1.243,11.081,0.543,10.26,0.543z"
      fill="currentColor"
    />
    <path
      d="M3.079,6.02c-0.426,0-0.761-0.334-0.761-0.761s0.334-0.761,0.761-0.761c0.426,0,0.761,0.334,0.761,0.761
	S3.504,6.02,3.079,6.02z M6,6.02c-0.426,0-0.761-0.334-0.761-0.761S5.573,4.499,6,4.499s0.761,0.334,0.761,0.761S6.426,6.02,6,6.02z
	 M8.86,6.02C8.435,6.02,8.1,5.686,8.1,5.259S8.435,4.499,8.86,4.499s0.761,0.334,0.761,0.761S9.286,6.02,8.86,6.02z"
      fill="#FFFFFF"
    />
  </svg>
);

const TranslationOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5512"
    width="1em"
    height="1em"
  >
    <path
      d="M608 416h288c35.36 0 64 28.48 64 64v416c0 35.36-28.48 64-64 64H480c-35.36 0-64-28.48-64-64v-288H128c-35.36 0-64-28.48-64-64V128c0-35.36 28.48-64 64-64h416c35.36 0 64 28.48 64 64v288z m0 64v64c0 35.36-28.48 64-64 64h-64v256.032c0 17.664 14.304 31.968 31.968 31.968H864a31.968 31.968 0 0 0 31.968-31.968V512a31.968 31.968 0 0 0-31.968-31.968H608zM128 159.968V512c0 17.664 14.304 31.968 31.968 31.968H512a31.968 31.968 0 0 0 31.968-31.968V160A31.968 31.968 0 0 0 512.032 128H160A31.968 31.968 0 0 0 128 159.968z m64 244.288V243.36h112.736V176h46.752c6.4 0.928 9.632 1.824 9.632 2.752a10.56 10.56 0 0 1-1.376 4.128c-2.752 7.328-4.128 16.032-4.128 26.112v34.368h119.648v156.768h-50.88v-20.64h-68.768v118.272H306.112v-118.272H238.752v24.768H192z m46.72-122.368v60.48h67.392V281.92H238.752z m185.664 60.48V281.92h-68.768v60.48h68.768z m203.84 488H576L668.128 576h64.64l89.344 254.4h-54.976l-19.264-53.664h-100.384l-19.232 53.632z m33.024-96.256h72.864l-34.368-108.608h-1.376l-37.12 108.608zM896 320h-64a128 128 0 0 0-128-128V128a192 192 0 0 1 192 192zM128 704h64a128 128 0 0 0 128 128v64a192 192 0 0 1-192-192z"
      fill="currentColor"
      p-id="5513"
    ></path>
  </svg>
);

const OverviewOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6575"
    width="1em"
    height="1em"
  >
    <path
      d="M485.9 487.6H315.6c-93.9 0-170.3-76.4-170.3-170.3S221.7 147 315.6 147s170.3 76.4 170.3 170.3v170.3zM315.6 191c-69.7 0-126.3 56.7-126.3 126.3S246 443.6 315.6 443.6h126.3V317.3c0-69.7-56.6-126.3-126.3-126.3z m390.8 296.6H536.1V317.3c0-93.9 76.4-170.3 170.3-170.3s170.3 76.4 170.3 170.3-76.4 170.3-170.3 170.3z m-126.3-44h126.3c69.7 0 126.3-56.7 126.3-126.3S776 191 706.4 191s-126.3 56.7-126.3 126.3v126.3zM706.4 877c-93.9 0-170.3-76.4-170.3-170.3V536.4h170.3c93.9 0 170.3 76.4 170.3 170.3S800.3 877 706.4 877zM580.1 580.4v126.3c0 69.7 56.7 126.3 126.3 126.3s126.3-56.7 126.3-126.3c0-69.7-56.7-126.3-126.3-126.3H580.1zM315.6 877c-93.9 0-170.3-76.4-170.3-170.3s76.4-170.3 170.3-170.3h170.3v170.3c0 93.9-76.4 170.3-170.3 170.3z m0-296.6c-69.7 0-126.3 56.7-126.3 126.3 0 69.7 56.7 126.3 126.3 126.3s126.3-56.7 126.3-126.3V580.4H315.6z"
      p-id="6576"
      fill="currentColor"
    ></path>
  </svg>
);

const CourseOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1555"
    width="1em"
    height="1em"
  >
    <path
      d="M838.3 80.3H442.8c-55.9 0-103.3 42.8-110.8 98.8-86.4 14.7-150.7 90.3-150.7 178.7 0 100 81.3 181.3 181.3 181.3s181.3-81.3 181.3-181.3c0-41.8-14.6-82.7-41.2-115-24.3-29.5-57.4-50.7-94-60.4 4.8-15.5 18.5-26.4 34.2-26.4h395.5c19.9 0 36.1 17.4 36.1 38.7v525.1c0 21.3-16.2 38.7-36.1 38.7H660.9v-61.6c0-41-18.9-79.6-51-104.9l118.7-238.5c4.5-9.1 5.2-19.3 2-28.9s-10-17.4-19-21.9c-18.7-9.3-41.5-1.7-50.8 17L539.3 563.9c-4-0.4-8-0.5-12-0.5h-69c-20.9 0-37.9 17-37.9 37.9s17 37.9 37.9 37.9h69c31.9 0 57.8 25.9 57.8 57.8v112.4c0 31.9-26 57.8-57.8 57.8h-69c-20.9 0-37.9 17-37.9 37.9s17 37.9 37.9 37.9h69c64.4 0 119.5-46.2 131.3-108.7h179.8c61.7 0 111.9-51.3 111.9-114.4V194.7c-0.1-63.1-50.3-114.4-112-114.4zM468.1 357.7c0 58.2-47.3 105.5-105.5 105.5s-105.5-47.3-105.5-105.5 47.3-105.5 105.5-105.5 105.5 47.3 105.5 105.5z"
      fill="currentColor"
      p-id="1556"
    ></path>
    <path
      d="M208.1 639.1H268c20.9 0 37.9-17 37.9-37.9s-17-37.9-37.9-37.9h-59.9c-73.7 0-133.6 59.9-133.6 133.6v112.4c0 73.7 59.9 133.6 133.6 133.6H268c20.9 0 37.9-17 37.9-37.9s-17-37.9-37.9-37.9h-59.9c-31.9 0-57.8-25.9-57.8-57.8V696.9c-0.1-31.9 25.9-57.8 57.8-57.8z"
      fill="currentColor"
      p-id="1557"
    ></path>
  </svg>
);

const AnthologyOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2573"
    width="1em"
    height="1em"
  >
    <path
      d="M111.872 734.56c3.744 0.448 7.392 1.312 11.232 1.408l416.032 63.648a31.456 31.456 0 0 0 20.736-3.84l448-256a32 32 0 0 0-31.744-55.552l-438.304 250.464L130.56 672.384A30.72 30.72 0 0 0 125.728 672C91.68 672 64 642.336 64 605.888c0-25.76 16.576-50.208 41.28-60.864 1.536-0.672 2.592-1.92 3.968-2.752 4.608 0.64 9.12 1.632 13.888 1.728l416.032 63.648a31.936 31.936 0 0 0 20.704-3.872l448-256a32 32 0 0 0-31.744-55.552l-438.304 250.464L130.56 480.384A30.72 30.72 0 0 0 125.728 480C91.68 480 64 450.336 64 413.888c0-25.792 16.416-49.696 40.192-60.384l435.264 62.176a31.936 31.936 0 0 0 20.416-3.904l448-256a31.968 31.968 0 0 0-11.072-59.424l-420.576-64a32.96 32.96 0 0 0-20 3.424l-475.424 256a31.872 31.872 0 0 0-8.032 6.144C29.536 320 0 365.088 0 413.888c0 38.72 16.736 73.12 42.752 96.96C16.352 535.328 0 569.792 0 605.888c0 38.656 16.704 73.024 42.656 96.864C16.32 727.04 0 761.28 0 797.888c0 70.848 54.976 128.672 123.104 130.08l416.032 63.648a31.456 31.456 0 0 0 20.736-3.84l448-256a32 32 0 0 0-31.744-55.552l-438.304 250.464L130.56 864.384A30.72 30.72 0 0 0 125.728 864C91.68 864 64 834.336 64 797.888c0-28.064 20.128-54.72 47.872-63.328zM508.64 145.696l70.752-35.36c15.744-7.872 42.88-12.288 60.288-9.792l160.672 22.944c17.408 2.496 18.784 10.976 3.04 18.848l-70.752 35.36c-15.744 7.872-42.88 12.288-60.288 9.792l-160.672-22.944c-17.44-2.528-18.816-10.976-3.04-18.848z"
      p-id="2574"
      fill="currentColor"
    ></path>
  </svg>
);

const SearchOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7586"
    width="1em"
    height="1em"
  >
    <path
      d="M1011.2 705.9456c0 62.2592-39.7824 112.5376-88.8832 112.5376H101.632c-49.0496 0-88.8832-50.2784-88.8832-112.5376V318.0544c0-62.2592 39.8336-112.5376 88.8832-112.5376h820.7872c49.152 0 88.8832 50.2784 88.8832 112.4352v387.9936h-0.1024z"
      fill="currentColor"
      p-id="7587"
    ></path>
    <path
      d="M979.2512 313.1392c0-44.9536-36.5056-81.4592-81.4592-81.4592H126.3104c-44.9536 0-81.4592 36.5056-81.4592 81.4592v397.6704c0 45.056 36.5056 81.4592 81.4592 81.4592h771.4816a81.408 81.408 0 0 0 81.4592-81.4592V313.1392z"
      fill="currentColor"
      p-id="7588"
    ></path>
    <path
      d="M720.9984 632.9856a157.9008 157.9008 0 0 1-145.1008-96.2048 156.8256 156.8256 0 0 1-12.3904-61.2864 157.9008 157.9008 0 0 1 96.2048-145.1008c19.4048-8.192 40.0384-12.3904 61.2864-12.3904a157.9008 157.9008 0 0 1 145.1008 96.2048c8.192 19.4048 12.3904 40.0384 12.3904 61.2864a157.1328 157.1328 0 0 1-96.2048 145.0496 155.9552 155.9552 0 0 1-61.2864 12.4416z m0-291.9936c-74.1888 0-134.5024 60.3648-134.5024 134.5024s60.3648 134.5024 134.5024 134.5024c74.1888 0 134.5024-60.3648 134.5024-134.5024S795.1872 340.992 720.9984 340.992zM907.1616 697.4464a35.584 35.584 0 0 1-25.2416-10.3936l-67.8912-65.8432 15.9744-16.4864 68.096 65.9968a12.8 12.8 0 0 0 9.1136 3.7376 12.7488 12.7488 0 0 0 12.8-12.8512 12.7488 12.7488 0 0 0-3.7376-9.0624l-0.1536-0.1536-65.8944-67.9424 16.4864-15.9744 65.8432 67.8912a35.6352 35.6352 0 0 1-25.3952 61.0816z"
      fill="currentColor"
      p-id="7589"
    ></path>
    <path
      d="M652.7488 543.7952a96 96 0 0 1-28.3136-68.352c0-25.8048 10.0352-50.0736 28.3136-68.3008l16.2304 16.2304a73.728 73.728 0 0 0 0 104.192l-16.2304 16.2304z"
      fill="currentColor"
      p-id="7590"
    ></path>
  </svg>
);

const TransferOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1853"
    width="1em"
    height="1em"
  >
    <path
      d="M957.74 656.26c-20.6-74.35-76.81-131.67-146.9-155.86 17.24-18.36 28.21-43.22 28.21-70.76 0-56.88-46.13-103.01-103.01-103.01s-103.01 46.13-103.01 103.01c0 27.54 10.97 52.4 28.21 70.76-35.16 12.09-66.73 32.69-92.26 59.34-29.78-22.17-63.6-38.96-99.65-49.71 35.38-27.32 58.22-70.31 58.22-118.46 0-82.63-67.18-149.81-149.81-149.81s-149.81 67.18-149.81 149.81c0 48.15 22.84 91.14 58.22 118.46-104.11 30.9-188.76 113.98-218.99 222.59-6.72 23.96-1.79 49.27 13.21 69.2 15 19.71 37.84 31.13 62.48 31.13h469.81c24.63 0 47.47-11.42 62.48-31.13 14.55-19.48 19.7-43.89 13.66-67.4h209.82c19.26 0 37.17-8.73 48.82-24.19 11.64-15.46 15.45-35.16 10.3-53.97z m-221.7-284.85c32.02 0 58.22 26.2 58.22 58.22s-26.2 58.22-58.22 58.22-58.22-26.2-58.22-58.22 26.2-58.22 58.22-58.22z m-463.31 20.16c0-57.77 47.25-105.02 105.02-105.02s105.02 47.25 105.02 105.02c0 58-47.25 105.02-105.02 105.02s-105.02-47.02-105.02-105.02z m366.8 383.15c-6.49 8.51-16.35 13.44-26.87 13.44H142.85c-10.53 0-20.38-4.93-26.87-13.44-6.49-8.51-8.51-19.71-5.6-30.23 33.14-119.58 143.09-203.11 267.38-203.11 60.46 0 117.34 19.71 163.92 53.74a306.389 306.389 0 0 1 34.26 29.56c18.59 19.04 34.71 40.98 47.47 64.94 7.39 14.33 13.66 29.11 18.81 44.79 0.9 3.36 2.02 6.72 2.91 10.08 2.91 10.52 0.89 21.72-5.6 30.23z m272.08-91.59c-1.79 2.46-5.82 6.49-12.99 6.49H672.9c-16.79-38.29-40.53-72.33-69.64-100.55 34.04-35.16 81.73-56.43 132.79-56.43 82.86 0 156.3 55.76 178.47 135.48 1.57 5.38 0.45 10.75-2.91 15.01zM468.16 193.65c8.71 8.71 22.96 8.71 31.67 0 43.7-43.7 114.8-43.54 158.34 0l1.11 1.11c-12.98-3.8-26.76-5.86-40.69-5.86-12.35 0-22.49 9.82-22.64 22.33-0.16 12.19 9.82 22.48 22.17 22.48 29.13 0.32 56.53 11.56 77.43 32.14l0.16 0.16c1.27 1.27 2.53 2.22 4.12 3.17 0.95 0.63 2.22 1.27 3.32 1.74 1.11 0.48 2.22 0.63 3.48 0.95 0.95 0.32 2.06 0.48 3.32 0.48 1.43 0.16 2.69 0.16 3.96-0.16 0.63 0 1.27 0 1.74-0.16 1.58-0.32 2.85-0.63 4.12-1.27 1.43-0.47 2.69-1.11 3.96-2.06 1.11-0.79 2.38-1.74 3.48-2.85 1.27-1.27 2.38-2.69 3.17-4.12 0.79-1.11 1.27-2.22 1.74-3.33 0.32-0.95 0.79-2.06 0.95-3.17 0.32-1.27 0.63-2.53 0.63-3.8 0.16-1.43 0.16-2.69-0.16-3.96 0-0.63-0.16-1.11-0.16-1.74-5.7-31.99-20.74-60.96-43.54-83.76-61.12-61.12-160.56-61.12-221.68 0-8.71 8.72-8.71 22.97 0 31.68z"
      fill="currentColor"
      p-id="1854"
    ></path>
  </svg>
);

const PasteOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4061"
    width="1em"
    height="1em"
  >
    <path
      d="M917.219556 277.105778h-108.714667V200.647111a72.817778 72.817778 0 0 0-72.760889-72.760889h-124.871111v-11.605333a53.361778 53.361778 0 0 0-53.248-53.248h-39.253333V55.751111c0-15.928889-13.084444-29.013333-29.013334-29.013333H404.935111c-15.928889 0-29.013333 13.084444-29.013333 29.013333v7.281778h-39.253334a53.361778 53.361778 0 0 0-53.248 53.248v11.605333H152.462222A72.817778 72.817778 0 0 0 79.758222 200.647111v610.133333A72.817778 72.817778 0 0 0 152.462222 883.484444H261.12v62.008889a72.817778 72.817778 0 0 0 72.760889 72.704h389.802667l266.24-266.126222V349.923556a72.817778 72.817778 0 0 0-72.760889-72.817778zM331.832889 116.280889c0-2.616889 2.275556-4.835556 4.892444-4.835556h220.728889c2.673778 0 4.892444 2.275556 4.892445 4.835556v74.353778c0 2.616889-2.275556 4.892444-4.835556 4.892444H336.725333a4.892444 4.892444 0 0 1-4.835555-4.892444V116.280889zM261.233778 349.923556v485.262222H152.462222a24.405333 24.405333 0 0 1-24.291555-24.291556V200.647111c0-13.368889 10.922667-24.291556 24.291555-24.291555h131.015111v14.279111c0 29.354667 23.893333 53.304889 53.248 53.304889h220.728889c29.411556 0 53.304889-23.893333 53.304889-53.304889V176.355556h124.928c13.368889 0 24.291556 10.922667 24.291556 24.291555V277.048889h-426.097778a72.817778 72.817778 0 0 0-72.704 72.817778z m476.16 586.24v-144.554667c0-13.368889 10.808889-24.234667 24.177778-24.234667h144.554666l-168.732444 168.789334z m204.231111-217.201778h-180.053333c-40.049778 0-72.590222 32.540444-72.590223 72.647111v178.232889H333.937778a24.405333 24.405333 0 0 1-24.348445-24.291556V349.923556c0-13.312 10.979556-24.291556 24.348445-24.291556h583.281778c13.368889 0 24.291556 10.979556 24.291555 24.291556v369.038222z"
      fill="currentColor"
      p-id="4062"
    ></path>
    <path
      d="M835.982222 476.387556h-435.768889a24.234667 24.234667 0 0 0 0 48.412444h435.768889a24.291556 24.291556 0 0 0 24.234667-24.177778 24.291556 24.291556 0 0 0-24.234667-24.234666z m-193.649778 135.566222H400.270222a24.234667 24.234667 0 0 0 0 48.412444h242.062222a24.291556 24.291556 0 0 0 24.177778-24.177778 24.291556 24.291556 0 0 0-24.177778-24.234666z"
      fill="currentColor"
      p-id="4063"
    ></path>
  </svg>
);

const EpubOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6403"
    width="1em"
    height="1em"
  >
    <path
      d="M518.144 29.696v100.352H236.544c-6.144 0-8.192 2.048-8.192 8.192v666.624h566.272V27.648c12.288 0 23.552 2.048 34.816 6.144 33.792 13.312 55.296 37.888 64.512 73.728 1.024 5.12 2.048 10.24 2.048 16.384v776.192c0 23.552-9.216 44.032-25.6 61.44-13.312 15.36-29.696 25.6-49.152 30.72-8.192 2.048-16.384 4.096-24.576 4.096-189.44 0-378.88 1.024-569.344 0-48.128 0-87.04-33.792-98.304-80.896-1.024-6.144-1.024-12.288-1.024-18.432V132.096c0-36.864 16.384-65.536 46.08-86.016 15.36-10.24 32.768-15.36 52.224-15.36h282.624c3.072-1.024 6.144-1.024 9.216-1.024z m-49.152 868.352c0 25.6 20.48 44.032 43.008 44.032 24.576 0 41.984-19.456 43.008-41.984 1.024-24.576-22.528-44.032-43.008-45.056-22.528-1.024-44.032 21.504-43.008 43.008z"
      fill="#0079C1"
      p-id="6404"
    ></path>
    <path
      d="M741.376 29.696V368.64l-1.024 1.024c-35.84-48.128-71.68-96.256-107.52-145.408-19.456 21.504-38.912 43.008-59.392 64.512V29.696h167.936z"
      fill="#FFD204"
      p-id="6405"
    ></path>
    <path
      d="M284.672 584.704v-77.824h456.704v77.824H284.672z m456.704 76.8v67.584H284.672v-67.584h456.704zM284.672 351.232h344.064v77.824H284.672v-77.824z m0-65.536v-78.848h233.472v78.848H284.672z"
      fill="#BABABA"
      p-id="6406"
    ></path>
  </svg>
);

const HtmlOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6553"
    width="1em"
    height="1em"
  >
    <path
      d="M89.088 59.392l62.464 803.84c1.024 12.288 9.216 22.528 20.48 25.6L502.784 993.28c6.144 2.048 12.288 2.048 18.432 0l330.752-104.448c11.264-4.096 19.456-14.336 20.48-25.6l62.464-803.84c1.024-17.408-12.288-31.744-29.696-31.744H118.784c-17.408 0-31.744 14.336-29.696 31.744z"
      fill="#FC490B"
      p-id="6554"
    ></path>
    <path
      d="M774.144 309.248h-409.6l12.288 113.664h388.096l-25.6 325.632-227.328 71.68-227.328-71.68-13.312-169.984h118.784v82.944l124.928 33.792 123.904-33.792 10.24-132.096H267.264L241.664 204.8h540.672z"
      fill="#FFFFFF"
      p-id="6555"
    ></path>
  </svg>
);

const DocOutLined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6702"
    width="1em"
    height="1em"
  >
    <path
      d="M950.272 843.776H527.36c-16.384 0-29.696-13.312-29.696-29.696V210.944c0-16.384 13.312-29.696 29.696-29.696h422.912c16.384 0 29.696 13.312 29.696 29.696v603.136c0 16.384-13.312 29.696-29.696 29.696z"
      fill="#E8E8E8"
      p-id="6703"
    ></path>
    <path
      d="M829.44 361.472H527.36c-16.384 0-29.696-13.312-29.696-29.696s13.312-29.696 29.696-29.696H829.44c16.384 0 29.696 13.312 29.696 29.696 0 15.36-13.312 29.696-29.696 29.696z m0 120.832H527.36c-16.384 0-29.696-13.312-29.696-29.696s13.312-29.696 29.696-29.696H829.44c16.384 0 29.696 13.312 29.696 29.696s-13.312 29.696-29.696 29.696z m0 119.808H527.36c-16.384 0-29.696-13.312-29.696-29.696s13.312-29.696 29.696-29.696H829.44c16.384 0 29.696 13.312 29.696 29.696s-13.312 29.696-29.696 29.696z m0 120.832H527.36c-16.384 0-29.696-13.312-29.696-29.696s13.312-29.696 29.696-29.696H829.44c16.384 0 29.696 13.312 29.696 29.696s-13.312 29.696-29.696 29.696z"
      fill="#B2B2B2"
      p-id="6704"
    ></path>
    <path
      d="M607.232 995.328l-563.2-107.52V135.168l563.2-107.52v967.68z"
      fill="#0D47A1"
      p-id="6705"
    ></path>
    <path
      d="M447.488 696.32h-71.68l-47.104-236.544c-3.072-13.312-4.096-27.648-4.096-40.96h-1.024c-1.024 16.384-3.072 30.72-5.12 40.96L269.312 696.32H194.56l-74.752-368.64h70.656l39.936 245.76c2.048 10.24 3.072 24.576 4.096 41.984h1.024c0-13.312 3.072-27.648 6.144-43.008l51.2-244.736h68.608l47.104 247.808c2.048 9.216 3.072 22.528 4.096 39.936h1.024c1.024-13.312 2.048-26.624 4.096-40.96l39.936-245.76H522.24L447.488 696.32z"
      fill="#FFFFFF"
      p-id="6706"
    ></path>
  </svg>
);

const NotificationOutlined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5268"
    width="1em"
    height="1em"
  >
    <path
      d="M861.575529 783.058824a30.117647 30.117647 0 0 1-30.117647-30.117648V378.096941C831.457882 202.541176 689.152 60.235294 513.626353 60.235294 338.070588 60.235294 195.764706 202.541176 195.764706 378.096941V752.941176a30.117647 30.117647 0 0 1-30.117647 30.117648H105.411765v60.235294h813.17647v-60.235294h-57.012706zM918.588235 722.823529a60.235294 60.235294 0 0 1 60.235294 60.235295v60.235294a60.235294 60.235294 0 0 1-60.235294 60.235294H105.411765a60.235294 60.235294 0 0 1-60.235294-60.235294v-60.235294a60.235294 60.235294 0 0 1 60.235294-60.235295h30.117647V378.096941C135.529412 169.261176 304.790588 0 513.626353 0c208.805647 0 378.066824 169.261176 378.066823 378.096941V722.823529H918.588235z m-481.882353 210.82353h180.705883a90.352941 90.352941 0 0 1-180.705883 0z"
      fill="currentColor"
      p-id="5269"
    ></path>
  </svg>
);

const HandBookOutlined = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4305"
    width="1em"
    height="1em"
  >
    <path
      d="M704 192v384H257.6c-24 0-46.4 6.4-65.6 17.6V256.8c0-36 28.8-64.8 64.8-64.8H704m64-64H256.8C185.6 128 128 185.6 128 256.8v510.4c0 71.2 57.6 128.8 128.8 128.8H896V192h-64v640H257.6c-36 0-65.6-29.6-65.6-65.6v-60.8c0-36 29.6-65.6 65.6-65.6H768V128z m0 576H256v64h512v-64z"
      fill="currentColor"
      p-id="4306"
    ></path>
  </svg>
);

const MergeSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6177"
    width="1em"
    height="1em"
  >
    <path
      d="M832 938.666667a320.36 320.36 0 0 1-294.846667-195.433334q-2-4.706667-3.82-9.453333-1.833333 4.753333-3.82 9.453333A319.74 319.74 0 0 1 234.666667 938.666667a21.333333 21.333333 0 0 1 0-42.666667c152.92 0 277.333333-124.413333 277.333333-277.333333V158.166667L377.753333 292.42a21.333333 21.333333 0 0 1-30.173333-30.173333l170.666667-170.666667a21.333333 21.333333 0 0 1 30.173333 0l170.666667 170.666667a21.333333 21.333333 0 1 1-30.173334 30.173333L554.666667 158.166667V618.666667c0 152.92 124.413333 277.333333 277.333333 277.333333a21.333333 21.333333 0 0 1 0 42.666667z"
      fill="currentColor"
      p-id="6178"
    ></path>
  </svg>
);

const VideoSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="24975"
    width="1em"
    height="1em"
  >
    <path
      d="M896 0 128 0C57.6 0 0 57.6 0 128l0 768c0 70.4 57.6 128 128 128l768 0c70.4 0 128-57.6 128-128L1024 128C1024 57.6 966.4 0 896 0zM748.8 563.2l-339.2 198.4C371.2 780.8 320 755.2 320 710.4L320 313.6c0-44.8 51.2-76.8 89.6-51.2l339.2 198.4C787.2 480 787.2 544 748.8 563.2z"
      fill="currentColor"
      p-id="24976"
    ></path>
  </svg>
);

const MergeSvg2 = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6789"
    width="1em"
    height="1em"
  >
    <path
      d="M180.878 119.396c-38.864 0-70.446 31.584-70.446 70.412s31.582 70.446 70.446 70.446c38.794 0 70.376-31.618 70.376-70.446S219.674 119.396 180.878 119.396z"
      fill="currentColor"
      p-id="6790"
    ></path>
    <path
      d="M180.81 775.618c-38.868 0-70.448 31.582-70.448 70.446 0 38.794 31.58 70.376 70.448 70.376 38.864 0 70.446-31.582 70.446-70.376C251.256 807.2 219.674 775.618 180.81 775.618z"
      fill="currentColor"
      p-id="6791"
    ></path>
    <path
      d="M843.192 775.618c-38.794 0-70.376 31.582-70.376 70.446 0 38.794 31.582 70.376 70.376 70.376 38.866 0 70.448-31.582 70.448-70.376C913.638 807.2 882.056 775.618 843.192 775.618z"
      fill="currentColor"
      p-id="6792"
    ></path>
    <path
      d="M898.232 677.578l0-272.72c0-148.28-120.656-268.902-268.902-268.902l-142.924 0 59.942-59.908L470.298 0l-124.366 124.298c-26.122-65.72-90.126-112.464-165.054-112.464-98.178 0-178.008 79.832-178.008 177.972 0 81.792 55.742 150.136 131.022 170.9l0 314.352C58.542 695.786 2.8 764.274 2.8 846.062 2.8 944.17 82.63 1024 180.81 1024c98.176 0 178.006-79.83 178.006-177.938 0-76.75-49.088-141.734-117.364-166.664L241.452 356.47c47.198-17.226 85.222-53.466 104.128-99.892l126.048 126.046 76.046-76.048-63.094-63.06 144.746 0c88.934 0 161.342 72.374 161.342 161.34l0 272.02c-72.338 22.546-125.418 89.424-125.418 169.184 0 98.108 79.83 177.938 177.938 177.938 98.178 0 178.008-79.83 178.008-177.938C1021.2 767.212 969.38 700.968 898.232 677.578zM180.81 916.44c-38.868 0-70.448-31.582-70.448-70.376 0-38.864 31.58-70.446 70.448-70.446 38.864 0 70.446 31.582 70.446 70.446C251.256 884.858 219.674 916.44 180.81 916.44zM180.878 260.254c-38.864 0-70.446-31.618-70.446-70.446s31.582-70.412 70.446-70.412c38.794 0 70.376 31.584 70.376 70.412S219.674 260.254 180.878 260.254zM843.192 916.44c-38.794 0-70.376-31.582-70.376-70.376 0-38.864 31.582-70.446 70.376-70.446 38.866 0 70.448 31.582 70.448 70.446C913.638 884.858 882.056 916.44 843.192 916.44z"
      fill="currentColor"
      p-id="6793"
    ></path>
  </svg>
);

const AdminSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4266"
    width="1em"
    height="1em"
  >
    <path
      d="M512 512c55.04 0 105.728 5.418667 152.064 16.298667a62.72 62.72 0 0 0-11.690667 13.738666l-2.986666 5.333334-9.6 19.285333A640.213333 640.213333 0 0 0 512 554.666667c-101.717333 0-186.24 19.498667-254.165333 58.026666a256 256 0 0 0-129.621334 212.096L128 835.413333V896a42.666667 42.666667 0 0 0 37.674667 42.368L170.666667 938.666667h373.632c11.52 9.386667 24.277333 14.208 37.461333 14.805333l6.656-0.042667 38.272-2.346666 5.504 3.2 13.525333 27.050666H170.666667a85.333333 85.333333 0 0 1-85.333334-85.333333v-60.586667a298.666667 298.666667 0 0 1 151.466667-259.882666c70.4-39.850667 155.733333-60.970667 256.213333-63.317334L512 512z m253.610667 42.666667a21.333333 21.333333 0 0 1 19.072 11.776l23.338666 46.72c9.173333 4.266667 17.92 9.386667 26.112 15.104l52.224-3.114667a21.333333 21.333333 0 0 1 19.754667 10.666667l29.482667 51.029333a21.333333 21.333333 0 0 1-0.682667 22.442667l-28.8 43.648a172.885333 172.885333 0 0 1 0 30.165333l28.8 43.605333a21.333333 21.333333 0 0 1 0.682667 22.442667l-29.44 51.029333a21.333333 21.333333 0 0 1-19.797334 10.666667l-52.224-3.114667a170.496 170.496 0 0 1-26.069333 15.061334l-23.381333 46.762666a21.333333 21.333333 0 0 1-15.104 11.392l-3.968 0.384h-58.965334a21.333333 21.333333 0 0 1-16.981333-8.405333l-2.133333-3.413333-23.381334-46.72c-9.130667-4.266667-17.877333-9.301333-26.069333-15.061334l-52.224 3.114667a21.333333 21.333333 0 0 1-17.450667-7.381333l-2.304-3.285334-29.482666-51.029333a21.333333 21.333333 0 0 1-1.194667-18.901333l1.877333-3.541334 28.8-43.648a172.885333 172.885333 0 0 1 0-30.08l-28.8-43.690666a21.333333 21.333333 0 0 1-2.346666-18.773334l1.664-3.669333 29.482666-51.029333a21.333333 21.333333 0 0 1 15.786667-10.496l3.968-0.170667 52.224 3.114667c8.192-5.76 16.938667-10.837333 26.112-15.104l23.338667-46.72a21.333333 21.333333 0 0 1 19.114666-11.776h58.965334z m-13.226667 42.666666h-32.597333l-24.064 48.213334-13.525334 6.314666a127.573333 127.573333 0 0 0-13.269333 7.168l-6.314667 4.138667-12.202666 8.576-53.930667-3.370667-16.469333 28.245334 29.866666 45.269333-1.28 14.805333a130.218667 130.218667 0 0 0-0.469333 11.306667l0.128 5.674667 0.341333 5.674666 1.28 14.805334-29.866666 44.885333 16.256 28.416 54.186666-3.2 12.16 8.533333a128 128 0 0 0 12.8 7.936l6.741334 3.413334 13.525333 6.272 23.978667 48.298666 32.64 0.085334 24.277333-48.384 13.482667-6.272c4.565333-2.133333 8.96-4.522667 13.226666-7.168l6.314667-4.138667 12.202667-8.576 53.930666 3.2 16.298667-28.245333-29.696-45.013334 1.28-14.805333c0.341333-3.797333 0.512-7.552 0.512-11.392l-0.128-5.674667-0.384-5.674666-1.28-14.805334 29.696-45.098666-16.298667-28.245334-53.930666 3.242667-12.202667-8.533333a128 128 0 0 0-12.8-7.978667l-6.784-3.370667-13.525333-6.272L752.384 597.333333z m-16.256 85.333334a85.333333 85.333333 0 1 1 0 170.666666 85.333333 85.333333 0 0 1 0-170.666666z m0 42.666666a42.666667 42.666667 0 1 0 0 85.333334 42.666667 42.666667 0 0 0 0-85.333334zM512 42.666667a213.333333 213.333333 0 0 1 9.258667 426.453333L512 469.333333a213.333333 213.333333 0 0 1-9.258667-426.453333L512 42.666667z m0 42.666666a170.666667 170.666667 0 1 0 0 341.333334 170.666667 170.666667 0 0 0 0-341.333334z"
      fill="currentColor"
      p-id="4267"
    ></path>
  </svg>
);

const TabSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4260"
    width="1em"
    height="1em"
  >
    <path
      d="M810.666667 810.666667 213.333333 810.666667 213.333333 213.333333 512 213.333333 512 384 810.666667 384M810.666667 128 213.333333 128C166.4 128 128 166.4 128 213.333333L128 810.666667C128 857.6 166.4 896 213.333333 896L810.666667 896C857.6 896 896 857.6 896 810.666667L896 213.333333C896 165.973333 857.6 128 810.666667 128Z"
      fill="currentColor"
      p-id="4261"
    ></path>
  </svg>
);

const LockFillSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7512"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path
      d="M512.804571 73.142857a207.238095 207.238095 0 0 1 207.238096 207.238095l-0.024381 60.952381H828.952381a73.142857 73.142857 0 0 1 73.142857 73.142857v438.857143a73.142857 73.142857 0 0 1-73.142857 73.142857H195.047619a73.142857 73.142857 0 0 1-73.142857-73.142857V414.47619a73.142857 73.142857 0 0 1 73.142857-73.142857h110.494476v-60.952381a207.238095 207.238095 0 0 1 207.238095-207.238095z m42.764191 463.238095h-73.142857v195.047619h73.142857v-195.047619zM512.804571 146.285714a134.095238 134.095238 0 0 0-134.095238 134.095238V341.333333h268.190477v-60.952381a134.095238 134.095238 0 0 0-134.095239-134.095238z"
      p-id="7513"
    ></path>
  </svg>
);

const ShortcutSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4427"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path
      d="M474.325333 180.992a32 32 0 0 1 3.072 64H324.992a80 80 0 0 0-79.872 75.733333v377.6a80 80 0 0 0 75.605333 80h377.6a80 80 0 0 0 80-75.733333v-153.6a32 32 0 0 1 64-3.072v152.405333a144 144 0 0 1-138.965333 143.914667H324.992a144 144 0 0 1-144-138.88V324.992a144 144 0 0 1 138.965333-144h5.034667z"
      p-id="4428"
    ></path>
    <path
      d="M748.16 215.509333l2.474667 2.176 54.272 52.522667 2.048 2.176a32 32 0 0 1-15.658667 57.813333H724.949333a181.333333 181.333333 0 0 0-181.248 175.872v16.128a32 32 0 0 1-64 3.072v-13.738666a245.376 245.376 0 0 1 229.76-244.864l-3.285333-3.114667a32 32 0 0 1 42.026667-48.170667z"
      p-id="4429"
    ></path>
  </svg>
);

const Dict2Svg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4092"
    width="1em"
    height="1em"
  >
    <path
      d="M490.02496 267.89888h-72.0896v300.89216h72.06912c52.51072 0 90.97216-12.288 115.13856-36.31104q35.40992-36.864 35.40992-114.11456c0-52.736-11.81696-91.29984-35.40992-114.81088-24.1664-23.94112-62.62784-35.6352-115.13856-35.6352z m0 0"
      fill="currentColor"
      p-id="4093"
    ></path>
    <path
      d="M747.7248 111.59552H276.2752a96.03072 96.03072 0 0 0-95.80544 95.80544v609.19808a96.01024 96.01024 0 0 0 95.80544 95.80544h471.4496a96.13312 96.13312 0 0 0 86.016-53.73952H282.624a35.96288 35.96288 0 0 1-35.86048-35.86048v-45.32224A35.96288 35.96288 0 0 1 282.624 741.60128h431.14496a130.08896 130.08896 0 0 0 129.76128-129.76128V207.40096a96.09216 96.09216 0 0 0-95.80544-95.80544z m-89.3952 459.55072c-35.40992 37.43744-86.79424 56.2176-155.27936 56.2176h-154.15296V209.32608h154.15296c68.48512 0 119.84896 18.78016 155.27936 56.2176 33.62816 35.08224 50.83136 86.016 50.83136 152.80128 0 66.23232-17.2032 117.16608-50.81088 152.80128z m0 0"
      fill="currentColor"
      p-id="4094"
    ></path>
  </svg>
);

const SelectAll = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1473"
    width="1em"
    height="1em"
  >
    <path
      d="M218.517333 245.013333l90.496-90.496a42.666667 42.666667 0 1 1 60.352 60.330667l-120.682666 120.682667a42.666667 42.666667 0 0 1-60.352 0L128 275.178667a42.666667 42.666667 0 1 1 60.330667-60.330667l30.186666 30.165333zM917.333333 234.666667a42.666667 42.666667 0 0 1-42.666666 42.666666H490.666667a42.666667 42.666667 0 1 1 0-85.333333h384a42.666667 42.666667 0 0 1 42.666666 42.666667zM218.517333 522.346667l90.496-90.496a42.666667 42.666667 0 1 1 60.352 60.330666l-120.682666 120.682667a42.666667 42.666667 0 0 1-60.352 0L128 552.512a42.666667 42.666667 0 1 1 60.330667-60.330667l30.186666 30.165334zM917.333333 533.333333a42.666667 42.666667 0 0 1-42.666666 42.666667H490.666667a42.666667 42.666667 0 1 1 0-85.333333h384a42.666667 42.666667 0 0 1 42.666666 42.666666zM218.517333 799.68l90.496-90.496a42.666667 42.666667 0 1 1 60.352 60.330667l-120.682666 120.682666a42.666667 42.666667 0 0 1-60.352 0L128 829.845333a42.666667 42.666667 0 1 1 60.330667-60.330666l30.186666 30.165333zM917.333333 832a42.666667 42.666667 0 0 1-42.666666 42.666667H490.666667a42.666667 42.666667 0 1 1 0-85.333334h384a42.666667 42.666667 0 0 1 42.666666 42.666667z"
      fill="currentColor"
      p-id="1474"
    ></path>
  </svg>
);

const Sort = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2464"
    width="1em"
    height="1em"
  >
    <path
      d="M499.712645 782.909297l-76.488784 66.198125V460.775809a47.971881 47.971881 0 0 0-17.355889-36.247697A64.201429 64.201429 0 0 0 364.039768 409.578497c-15.717575 0-30.718387 5.375718-41.879401 14.949615A47.971881 47.971881 0 0 0 304.855675 460.775809v388.331613l-76.539982-66.198125a64.406219 64.406219 0 0 0-41.623414-14.335247 64.099035 64.099035 0 0 0-41.316231 15.000812 48.023079 48.023079 0 0 0-17.355889 35.735724 47.767092 47.767092 0 0 0 16.639126 35.991711l177.552279 153.591936c5.478112 4.76135 12.031368 8.549951 19.198992 11.161014a67.170874 67.170874 0 0 0 45.360819 0c7.167624-2.559866 13.72088-6.399664 19.250189-11.161014l177.552278-153.591936a47.767092 47.767092 0 0 0 16.58793-35.991711 48.023079 48.023079 0 0 0-17.304692-35.735724 64.150232 64.150232 0 0 0-41.367428-15.000812 64.406219 64.406219 0 0 0-41.623415 14.335247h-0.102395zM879.340715 168.592749l-177.552279-153.591937a59.952053 59.952053 0 0 0-19.301387-11.109816 67.785241 67.785241 0 0 0-45.207226 0 59.900855 59.900855 0 0 0-19.301387 11.109816l-177.552278 153.591937a47.767092 47.767092 0 0 0-16.58793 35.99171 48.023079 48.023079 0 0 0 17.304692 35.786922c11.007422 9.471503 25.854643 14.847221 41.367428 14.949615 15.512786 0.153592 30.462401-5.017337 41.623415-14.335248l76.642376-66.198124v388.331612c0 13.618485 6.246072 26.622602 17.355889 36.247697 11.058619 9.573897 26.110629 14.949615 41.828204 14.949615 15.717575 0 30.718387-5.375718 41.828204-14.949615a47.971881 47.971881 0 0 0 17.407086-36.247697V174.787624l76.488785 66.198124c11.161014 9.317911 26.110629 14.488839 41.623414 14.335248 15.512786-0.102395 30.360006-5.478112 41.316231-14.949615a48.023079 48.023079 0 0 0 17.355889-35.786922 47.767092 47.767092 0 0 0-16.639126-35.99171z"
      fill="currentColor"
      p-id="2465"
    ></path>
  </svg>
);

const GroupSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4393"
    width="1em"
    height="1em"
  >
    <path
      d="M107.52 209.92h89.088c25.6 0 46.08-20.48 46.08-46.08s-20.48-46.08-46.08-46.08h-89.088c-55.296 0-100.352 45.056-100.352 100.352v586.752c0 55.296 45.056 100.352 100.352 100.352h89.088c25.6 0 46.08-20.48 46.08-46.08s-20.48-46.08-46.08-46.08h-89.088c-5.12 0-8.192-4.096-8.192-8.192V558.08h97.28c25.6 0 46.08-20.48 46.08-46.08s-20.48-46.08-46.08-46.08H99.328V218.112c0-4.096 3.072-8.192 8.192-8.192zM974.848 389.12H345.088c-23.552 0-43.008 19.456-43.008 43.008v160.768c0 23.552 19.456 43.008 43.008 43.008h628.736c23.552 0 43.008-19.456 43.008-43.008V432.128c0-23.552-18.432-43.008-41.984-43.008zM422.912 543.744c0 9.216-8.192 16.384-18.432 16.384h-1.024-1.024c-9.216 0-16.384-7.168-16.384-16.384v-63.488c0-9.216 7.168-16.384 16.384-16.384h2.048c10.24 0 18.432 7.168 18.432 16.384v63.488z m512-23.552c0 22.528-17.408 39.936-39.936 39.936H547.84c-22.528 0-39.936-17.408-39.936-39.936v-16.384c0-22.528 17.408-39.936 39.936-39.936h347.136c22.528 0 39.936 17.408 39.936 39.936v16.384zM974.848 33.792H345.088c-23.552 0-43.008 19.456-43.008 43.008v160.768c0 23.552 19.456 43.008 43.008 43.008h628.736c23.552 0 43.008-19.456 43.008-43.008V75.776c0-23.552-18.432-41.984-41.984-41.984zM422.912 188.416c0 9.216-8.192 16.384-18.432 16.384h-1.024-1.024c-9.216 0-16.384-7.168-16.384-16.384v-63.488c0-9.216 7.168-16.384 16.384-16.384h2.048c10.24 0 18.432 7.168 18.432 16.384v63.488z m512-23.552c0 22.528-17.408 39.936-39.936 39.936H547.84c-22.528 0-39.936-17.408-39.936-39.936v-16.384c0-22.528 17.408-39.936 39.936-39.936h347.136c22.528 0 39.936 17.408 39.936 39.936v16.384zM974.848 745.472H345.088c-23.552 0-43.008 19.456-43.008 43.008v160.768c0 23.552 19.456 43.008 43.008 43.008h628.736c23.552 0 43.008-19.456 43.008-43.008V787.456c0-23.552-18.432-41.984-41.984-41.984zM422.912 900.096c0 9.216-8.192 16.384-18.432 16.384h-1.024-1.024c-9.216 0-16.384-7.168-16.384-16.384v-63.488c0-9.216 7.168-16.384 16.384-16.384h2.048c10.24 0 18.432 7.168 18.432 16.384v63.488z m512-23.552c0 22.528-17.408 39.936-39.936 39.936H547.84c-22.528 0-39.936-17.408-39.936-39.936V860.16c0-22.528 17.408-39.936 39.936-39.936h347.136c22.528 0 39.936 17.408 39.936 39.936v16.384z"
      p-id="4394"
      fill="currentColor"
    ></path>
  </svg>
);

const MoreSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5057"
    width="1em"
    height="1em"
  >
    <path
      d="M227.14123 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C321.728492 456.087573 279.288914 413.647995 227.14123 413.647995z"
      fill="currentColor"
      p-id="5058"
    ></path>
    <path
      d="M510.903016 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C605.490278 456.087573 563.051723 413.647995 510.903016 413.647995z"
      fill="currentColor"
      p-id="5059"
    ></path>
    <path
      d="M794.665825 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C889.253086 456.087573 846.813508 413.647995 794.665825 413.647995z"
      fill="currentColor"
      p-id="5060"
    ></path>
  </svg>
);
export const DictIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DictSvg} {...props} />
);
export const TermIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TermSvg} {...props} />
);

export const SuggestionIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SuggestionSvg} {...props} />
);

export const LockIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LockSvg} {...props} />
);

export const UnLockIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UnLockSvg} {...props} />
);

export const HandOutlinedIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HandOutlined} {...props} />
);

export const ColumnOutlinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={ColumnOutlined} {...props} />;

export const ChapterOutlinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={ChapterOutlined} {...props} />;

export const ArticleOutlinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={ArticleOutlined} {...props} />;

export const ParagraphOutlinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={ParagraphOutlined} {...props} />;

export const ProgressOutlinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={ProgressOutlined} {...props} />;

export const StartUpIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={StartUp} {...props} />
);

export const TermOutlinedIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TermOutlined} {...props} />
);

export const TermIcon2 = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Term} {...props} />
);
export const JsonOutlinedIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={JsonOutlined} {...props} />
);

export const ThemeOutlinedIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ThemeOutlined} {...props} />
);

export const TemplateOutlinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={TemplateOutLined} {...props} />;

export const CommentOutlinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={CommentOutLined} {...props} />;

export const CommentFillIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CommentFill} {...props} />
);

export const TranslationOutLinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={TranslationOutLined} {...props} />;

export const OverviewOutLinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={OverviewOutLined} {...props} />;

export const CourseOutLinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={CourseOutLined} {...props} />;

export const AnthologyOutLinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={AnthologyOutLined} {...props} />;

export const SearchOutLinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={SearchOutLined} {...props} />;

export const TransferOutLinedIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={TransferOutLined} {...props} />;

export const PasteOutLinedIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PasteOutLined} {...props} />
);

export const EpubIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EpubOutLined} {...props} />
);

export const HtmlIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HtmlOutLined} {...props} />
);

export const DocIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DocOutLined} {...props} />
);

export const NotificationIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NotificationOutlined} {...props} />
);

export const HandBookIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HandBookOutlined} {...props} />
);

export const MergeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MergeSvg} {...props} />
);
export const VideoIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={VideoSvg} {...props} />
);

export const MergeIcon2 = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MergeSvg2} {...props} />
);

export const AdminIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AdminSvg} {...props} />
);

export const TabIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TabSvg} {...props} />
);

export const LockFillIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LockFillSvg} {...props} />
);

export const UnLockFillIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UnLockFillSvg} {...props} />
);

export const ShortcutIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ShortcutSvg} {...props} />
);

export const Dict2SvgIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Dict2Svg} {...props} />
);

export const SelectAllIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SelectAll} {...props} />
);

export const SortIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Sort} {...props} />
);

export const GroupIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GroupSvg} {...props} />
);

export const MoreIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MoreSvg} {...props} />
);
